import {React, Component, _, Modal, Header, Body} from 'utils';
import {Creators} from 'model'
import PropTypes from 'prop-types';
import './filter3.less';

export default class Filter3 extends Component {

	constructor(props)
	{
		super(props);

		var showFilters = {};
		var queryFilters = {};

		props.filters.forEach((filter, fi) =>
		{
			showFilters[filter.name] = false;
			queryFilters[filter.name] = '';
		});

		this.state = {
			filters: props.filters,
			showFilters: showFilters,
			queryFilters: queryFilters
		};
	}

	componentDidMount()
	{
		document.addEventListener('click', this.handleOutsideFilterClick);
	}

	componentWillUnmount()
	{
		document.removeEventListener('click', this.handleOutsideFilterClick);
	}

	handleOutsideFilterClick = (event) =>
	{
		if (event.target.closest(".dropdown") == null)
		{
			let newState = Object.assign({}, this.state);
			this.props.filters.forEach((filter, fi) =>
			{
				newState.showFilters[filter.name] = false;
			});
			this.setState(newState);
		}
	};

	filterButtonClick = (event) =>
	{
		let filter = $(event.target).data('filter');
		let newState = Object.assign({}, this.state);
		let buttonState = !newState.showFilters[filter];
		this.props.filters.forEach((filter, fi) =>
		{
			newState.showFilters[filter.name] = false;
		});
		newState.showFilters[filter] = buttonState;
		this.setState(newState);
	};

	filterItemClick = (event) =>
	{
		let {onFilterClick} = this.props;
		let filter = $(event.target).data('filter');
		let newState = Object.assign({}, this.state);
		newState.showFilters[filter] = true;
		this.setState(newState);
		onFilterClick(event);
	};

	filterSearch = (event) =>
	{
		let filter = $(event.target).data('filter');
		let newState = Object.assign({}, this.state);
		newState.queryFilters[filter] = event.target.value;
		this.setState(newState);
	};

	render()
	{
		let { filters, onTagClick } = this.props;
		let { showFilters, queryFilters } = this.state;

		let filterButtons = [];

		let tags = [];

		filters.forEach((filter, fi) =>
		{
			let dropDownItems = [];

			filter.items.forEach((item, fii) =>
			{
				var activeClass = '';
				if (item.active)
				{
					activeClass = ' active';
					tags.push(
						<span key={'ti_' + filter.name + '_' + item.index} className="filters-active-item"
							  onClick={onTagClick} data-filter={filter.name} data-name={item.name}
							  data-index={item.index}>
							{item.name}
						</span>
					);
				} else if (queryFilters[filter.name].length > 0 && item.name.toLowerCase().indexOf(queryFilters[filter.name].toLowerCase()) === -1) {
					return;
				}

				dropDownItems.push(
					<span key={'di_' + filter.name + '_' + fii}
						  className={"dropdown-item col-12 filter-item" + activeClass}
						  onClick={this.filterItemClick} data-filter={filter.name} data-name={item.name}
						  data-index={item.index}>
						{item.name}
					</span>
				);
			});

			let filterId = 'fi_' + filter.name;
			let showClass = "";
			if (showFilters[filter.name])
			{
				showClass = " show";
			}
			filterButtons.push(
				<div key={'fb'+fi} className={"dropdown col-md-3" + showClass} data-filter={filter.name}>
					<button className="btn btn-secondary btn-dropdown" type="button" id={filterId}
							data-filter={filter.name} onClick={this.filterButtonClick}>
						{_('Filter ' + filter.name.toLowerCase())}
					</button>
					<div className={"dropdown-menu" + showClass} data-filter={filter.name}>
						<div className="search">
							<input type="text" onChange={this.filterSearch} data-filter={filter.name} />
						</div>
						{dropDownItems}
					</div>
				</div>
			);
		});

		return (
			<div className="filters-3">
				<div className="row">
					{filterButtons}
				</div>
				<div className="filters-active row no-gutters">
					{tags}
				</div>
			</div>
		);
	}
}

Filter3.propTypes = {
	filters: PropTypes.array.isRequired,
	onFilterClick: PropTypes.func.isRequired,
	onTagClick: PropTypes.func.isRequired
	// query: PropTypes.string.isRequired,
	// handleChange: PropTypes.func.isRequired,
	// onOkClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/components/elements/filter3.js